<template lang="pug">
  div
    .title.mb-3 Материалы урока
    div(v-if="isFiles")
      div.mb-9(v-for="(m, i) in files" class="text-left")
        image-dialog(
          v-if="isImage(m.file_name)"
          :url="m.url"
          :title="m.name"
          :key="i"
        )
        v-btn(
          v-else
          large
          :key="i"
          :href="m.url"
          target="_blank"
          text
        )
          v-icon.mr-4(
            color="secondary"
            left
            large
          ) mdi-attachment
          | {{ m.name }}
    div(
      v-else
      key="empty"
    )
      p Материалы урока отсутствуют
</template>

<script>
import ImageDialog from '@/components/Global/ImageDialog.vue';

export default {
  name: 'ContentFiles',
  components: {
    ImageDialog,
  },
  props: {
    files: { type: Array, default: null },
  },
  computed: {
    isFiles() {
      return this.files.length;
    },
  },
  methods: {
    isImage(url) {
      return ['png', 'jpg'].includes(url.substr(-3));
    },
  },
};
</script>
